import Vue from "vue";
import VueRouter from "vue-router";
import VueGtag from "vue-gtag";

Vue.use(VueRouter);

var Single = { template: "<div></div>" };

const router = new VueRouter({
  mode: "history",
  routes: [{ path: "*", component: Single }],
});

Vue.use(VueGtag, {
  config: {
    id: "G-CD3R06RP6D",
    params: {
      send_page_view: false,
    },
  },
});

// console.log('actual', _actual);

let _default;

if (_actual.object) {
  _default = {
    tag: _actual.object.taxonomy == "post_tag" ? _actual.Tag : "",
    category: _actual.object.taxonomy == "category" ? _actual.Category : "",
    source: _actual.object.taxonomy == "source" ? _actual.Source : "",
    region: _actual.object.taxonomy == "region" ? _actual.Region : "",
    s: _actual.search,
    lang: app_ajax.lang,
  };
} else {
  _default = {
    tag: "",
    category: "",
    source: "",
    region: "",
    s: _actual.search,
    lang: app_ajax.lang,
  };
}



var Products = {
  vueApp: null,

  initVue: function () {
    Products.vueApp = new Vue({
      router,
      el: "#products",
      data: {
        loading: true,
        error: null,

        Products: [],

        total_pages: 1,
        total_results: 0,
        total_results_filtered: 0,

        filters: {
          action: "products",
          tag: _actual.Tag,
          category: _actual.Category,
          source: _actual.Source,
          region: _actual.Region,
          s: _actual.search,
          page: 1,
        },

        update: false,

        filters_data: {
          categories: [],
          tags: [],
          sources: [],
          regions: [],
        },

        filters_filtered: {
          tags: [],
          categories: [],
          sources: [],
          regions: [],
        },
      },

      created: function () {
        this.getCategories();
        this.getTags();
        this.getSources();
        this.getRegions();

        this.initData();

        this.debouncedFetch = this.debounce(this.fetchData, 1000);
      },

      mounted: function () {
        router.afterEach((to, from) => {
          if (typeof gtag === 'function') {

            if(to.path !== from.path) {
              gtag('event', 'page_view', {
                'app_name': 'Caricoos Crop',
                'lang': app_ajax.lang,
                'page_location': to.fullPath,
                'page_path': to.path,
                'page_title': document.title,
                'type': _actual.object.taxonomy ? _actual.object.taxonomy : 'product',
                'category': to.query.category,
                'source': to.query.source,
                'tag': to.query.tag,
                'region': to.query.region,
                'search': to.query.s,
              });
            }

          }
        });
      },

      watch: {
        "$route.query": function (to, from) {
          //console.log("TO", to, "FRM", from);
        },
        $route: function (to, from) {
          console.log("TO", to, "FRM", from);
          // console.log('is Cat', Products.isTaxonomy.category(), 'is Tax', Products.isTaxonomy.tag(), 'is Source', Products.isTaxonomy.source());

          if (to.path !== from.path) {
            if (Products.isTaxonomy.category()) {
              var cat = Object.values(this.filters_data.categories.ids).filter(
                (_cat) => _cat.link == to.path
              );
              // console.log(cat);
              this.filters.category = cat[0].cat_ID;
            }
            if (Products.isTaxonomy.tag()) {
              var tag = this.filters_data.tags.filter(
                (_tag) => _tag.link == to.path
              );
              // console.log(tag);
              this.filters.tag = tag[0].term_id;
            }
            if (Products.isTaxonomy.source()) {
              var source = this.filters_data.sources.filter(
                (_src) => _src.link == to.path
              );
              // console.log(source);
              this.filters.source = source[0].term_id;
            }
            // console.log('////', this.filters);
          }

          if (
            typeof to.query.s == "undefined" ||
            to.query.s == "" ||
            to.query.s.length > 3
          ) {
            // this.fetchData();
            this.debouncedFetchData();
          }

          if (
            to.query.tag == "" &&
            to.query.category == "" &&
            to.query.source == "" &&
            to.query.region == "" &&
            to.query.s == "" &&
            this.update
          ) {
            //const query = {};
            //this.$router.replace({ query }).catch(err => console.log(err));
            const query = Object.assign({}, {});
            this.$router.replace({ path: to.path, query });
            this.filters.category = "";
            this.filters.tag = "";
            this.filters.source = "";
            this.update = false;
          }
        },
      },

      computed: {
        query_cat: {
          get() {
            if (Products.isTaxonomy.category()) {
              if (Number.isInteger(this.filters.category)) {
                return this.filters.category;
              } else {
                return _actual.object.term_id;
              }
            } else {
              return this.$route.query.category
                ? this.$route.query.category
                : "";
            }
          },
          set(value) {
            if (Products.isTaxonomy.category()) {
              this.updateCat(value);
            } else {
              this.updateQuery("category", value);
            }
          },
        },
        query_tag: {
          get() {
            if (Products.isTaxonomy.tag()) {
              if (Number.isInteger(this.filters.tag)) {
                return this.filters.tag;
              } else {
                return _actual.object.term_id;
              }
            } else {
              return this.$route.query.tag ? this.$route.query.tag : "";
            }
          },
          set(value) {
            if (Products.isTaxonomy.tag()) {
              this.updateTag(value);
            } else {
              this.updateQuery("tag", value);
            }
          },
        },
        query_source: {
          get() {
            if (Products.isTaxonomy.source()) {
              if (Number.isInteger(this.filters.source)) {
                return this.filters.source;
              } else {
                return _actual.object.term_id;
              }
            } else {
              return this.$route.query.source ? this.$route.query.source : "";
            }
          },
          set(value) {
            if (Products.isTaxonomy.source()) {
              this.updateSource(value);
            } else {
              this.updateQuery("source", value);
            }
          },
        },

        query_region: {
          get() {
            return this.$route.query.region ? this.$route.query.region : "";
          },
          set(value) {
            this.updateQuery("region", value);
          },
        },

        query_search: {
          get() {
            return this.$route.query.s ? this.$route.query.s : "";
          },
          set(value) {
            this.updateQuery("s", value);
          },
        },

        options_category: function () {
          // if total products > 0 then show filtered categories
          if (this.total_results_filtered > 0) {
            return this.filters_filtered.categories.family;
          } else {
            return this.filters_data.categories.family;
          }
        },

        options_tag: function () {
          // if total products > 0 then show filtered tags
          if (this.total_results_filtered > 0) {
            return this.filters_filtered.tags;
          } else {
            return this.filters_data.tags;
          }
        },

        options_source: function () {
          // if total products > 0 then show filtered sources
          if (this.total_results_filtered > 0) {
            return this.filters_filtered.sources;
          } else {
            return this.filters_data.sources;
          }
        },

        options_region: function () {
          if (this.total_results_filtered > 0) {
            return this.filters_filtered.regions;
          } else {
            return this.filters_data.regions;
          }
        },
      },

      methods: {
        getUrlShare: function (encode) {
          if (encode) {
            return encodeURIComponent(window.location.href);
          } else {
            return window.location.href;
          }
        },
        getUrl: function () {
          // console.log("actual",  _actual);
          // console.log("default", _default);
          // console.log("route", this.$route.query);

          let _query = Object.assign({}, _default, this.$route.query);

          // console.log("CAT", Products.isTaxonomy.category(), this.filters.category, Number.isInteger(this.filters.category));
          if (
            Products.isTaxonomy.category() &&
            Number.isInteger(this.filters.category)
          ) {
            var cat = this.filters.category;
            _query.category = this.filters_data.categories.ids[cat].slug;
          }

          // console.log(this.filters);
          // console.log("TAG", Products.isTaxonomy.tag(), this.filters.tag, Number.isInteger(this.filters.tag));
          if (Products.isTaxonomy.tag() && Number.isInteger(this.filters.tag)) {
            // console.log(this.filters_data.tags);
            var tag = this.filters_data.tags.filter(
              (_tag) => _tag.term_id == this.filters.tag
            );
            // console.log("FILTERED", tag);
            _query.tag = tag[0].slug;
          }

          if (
            Products.isTaxonomy.source() &&
            Number.isInteger(this.filters.source)
          ) {
            // console.log(this.filters_data.tags);
            var source = this.filters_data.sources.filter(
              (_source) => _source.term_id == this.filters.source
            );
            // console.log("FILTERED", tag);
            _query.source = source[0].slug;
          }

          let query = Object.keys(_query)
            .map(
              (k) => encodeURIComponent(k) + "=" + encodeURIComponent(_query[k])
            )
            .join("&");

          let url =
            app_ajax.ajax_url +
            "?action=products&" +
            query +
            "&security=" +
            app_ajax.security +
            "&lang=" +
            app_ajax.lang;
          return url;
        },

        updateQuery: function (name, value) {
          const query = Object.assign({}, this.$route.query);
          query[name] = value;

          this.$router.push({ query });
        },

        updateUrl: function (path, name = "") {
          
          function decodeHtmlEntities(str) {
            var parser = new DOMParser();
            var doc = parser.parseFromString(str, 'text/html');
            return doc.documentElement.textContent;
          }

          const query = Object.assign({}, this.$route.query);
          document.title = decodeHtmlEntities(name);
          this.$router.push({ path: path, query });
        },

        goToProducts: function () {
          // const query = Object.assign({}, this.$route.query);
          // this.$router.push({ path: '/products/', query });

          let url = "";
          if (app_ajax.lang == "en") {
            url = "/products/";
          } else {
            url = "/es/productos/";
          }

          window.location.href = url + window.location.search;
        },

        updateCat: function (value) {
          if(value == this.filters.category) return;

          this.filters.category = value;
          // console.log("updateCat");
          // console.log(value);
          if (value == "") {
            // console.log('reset nav go to /products');

            _actual.Category = "";
            _actual.object = {};
            _default.category = "";

            this.goToProducts();
          } else {
            let _cat = this.filters_data.categories.ids[value];
            // console.log(_cat);
            this.updateUrl(_cat.link, _cat.seo_title);

            if (_cat.category_parent !== 0) {
              let _parent =
                this.filters_data.categories.ids[_cat.category_parent];
              this.updateSideBar(_parent);
            } else {
              this.updateSideBar(_cat);
            }
          }
        },

        updateTag: function (value) {
          if(value == this.filters.tag) return;

          this.filters.tag = value;

          if (value == "") {
            _actual.Tag = "";
            _actual.object = {};
            _default.tag = "";

            this.goToProducts();
          } else {
            this.filters.tag = value;
            var tag = this.filters_data.tags.filter(
              (_tag) => _tag.term_id == value
            );
            var path = tag[0].link;

            this.updateUrl(path, tag.seo_title);
          }
        },

        updateSource: function (value) {
          if(value == this.filters.source) return;

          this.filters.source = value;

          if (value == "") {
            _actual.Source = "";
            _actual.object = {};
            _default.source = "";

            this.goToProducts();
          } else {
            this.filters.source = value;
            //console.log(this.filters_data.sources);
            var source = this.filters_data.sources.filter(
              (_source) => _source.term_id == value
            );
            console.log(value, source);
            var path = source[0].link;

            this.updateUrl(path, source.seo_title);
          }
        },

        updateSideBar: function (category, event) {
          if (event) {
            // console.log(event);
            event.preventDefault();
          }
          let sidebarCats = document.getElementsByClassName(
            "products-sidebar__category"
          );
          for (let element of sidebarCats) {
            element.classList.remove("is-active");
          }

          let sidebarActive = document.getElementById(
            "sidebar_cat_" + category.slug
          );
          sidebarActive.classList.add("is-active");
        },

        resetFilters: function () {
          let _reset = {
            tag: "",
            category: "",
            source: "",
            region: "",
            s: "",
          };

          _actual = {
            Category: "",
            Region: "",
            Source: "",
            Tag: "",
            object: {},
            search: "",
          };

          const query = Object.assign({}, _reset);
          let url = "";
          if (app_ajax.lang == "en") {
            url = "/products/";
          } else {
            url = "/es/productos/";
          }
          this.$router.push({ path: url, query });
          this.update = true;
          this.initData();
        },


        throttle: function(func, limit) {
          let inThrottle;
          return function() {
            const args = arguments;
            const context = this;
            if (!inThrottle) {
              func.apply(context, args);
              inThrottle = true;
              setTimeout(() => inThrottle = false, limit);
            }
          };
        },

        initData: function () {
          this.error = null;
          // this.loading = true;
          console.log('init data');
          this.fetchData();
        },

        // Using the debounce function
        debouncedFetchData: function() {
          this.debouncedFetch();
        },

        debounce: function(func, delay) {
          console.log('debounce products');
          let debounceTimer;
          return function() {
            const context = this;
            const args = arguments;
            clearTimeout(debounceTimer);
            debounceTimer = setTimeout(() => func.apply(context, args), delay);
          }
        },
        

        fetchData: function () {
          console.log('fetchData');
          this.error = null;
          this.loading = true;

          let url = this.getUrl();
          // console.log(url);

          fetch(url, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          })
            .then((res) => res.json())
            .catch((error) => {
              this.loading = false;
              this.error = true;
              console.error("Error:", error);
            })
            .then((response) => {
              console.log("Success:", response);

              this.total_pages = response.pages;
              this.total_results = response.total;
              this.total_results_filtered = response.total;

              this.Products = response.response;
              this.filters_filtered = response.filters;

              this.loading = false;
              this.error = false;

              if (typeof gtag === 'function') {
                var to = this.$route;
                var event = {
                  'app_name': 'Caricoos Crop',
                  'lang': app_ajax.lang,
                  'page_location': to.fullPath,
                  'page_path': to.path,
                  'page_title': document.title,
                  'type': _actual.object.taxonomy ? _actual.object.taxonomy : 'product',
                  'category': response.params.category || '',
                  'source': response.params.source || '',
                  'tag': response.params.tag || '',
                  'region': response.params.region || '',
                  'search': response.params.search || '',
                  'results': this.total_results_filtered,
                };
                console.log('gtag', event );
                gtag('event', 'crop_products_view', event);
              }
            });
        },

        getCategories: function () {
          // this.loading = true;
          let params = new URLSearchParams({
            action: "categories",
            lang: app_ajax.lang,
          });
          let url = app_ajax.ajax_url + "?" + params.toString();
          fetch(url, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          })
            .then((res) => res.json())
            .catch((error) => console.error("Error:", error))
            .then((response) => {
              // console.log("Success:", response);
              // this.loading = false;
              this.filters_data.categories = response;
            });
        },

        val_category: function (category) {
          if (Products.isTaxonomy.category()) {
            return category.term_id;
          } else {
            return category.slug;
          }
        },

        echoText: function (value) {
          return value.replace(/&amp;/g, "&");
        },

        getTags: function () {
          let params = new URLSearchParams({
            action: "tags",
            lang: app_ajax.lang,
          });
          let url = app_ajax.ajax_url + "?" + params.toString();

          fetch(url, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          })
            .then((res) => res.json())
            .catch((error) => console.error("Error:", error))
            .then((response) => {
              // console.log("Success:", response);
              // this.loading = false;
              this.filters_data.tags = response;
            });
        },

        val_tags: function (tag) {
          if (Products.isTaxonomy.tag()) {
            return tag.term_id;
          } else {
            return tag.slug;
          }
        },

        getSources: function () {
          // this.loading = true;
          let params = new URLSearchParams({
            action: "sources",
            lang: app_ajax.lang,
          });
          let url = app_ajax.ajax_url + "?" + params.toString();

          fetch(url, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          })
            .then((res) => res.json())
            .catch((error) => console.error("Error:", error))
            .then((response) => {
              // console.log("Success:", response);
              // this.loading = false;
              this.filters_data.sources = response;
            });
        },

        val_sources: function (source) {
          if (Products.isTaxonomy.source()) {
            return source.term_id;
          } else {
            return source.slug;
          }
        },

        getRegions: function () {
          // this.loading = true;
          let params = new URLSearchParams({
            action: "regions",
            lang: app_ajax.lang,
          });
          let url = app_ajax.ajax_url + "?" + params.toString();

          fetch(url, {
            method: "GET",
            headers: {
              "Content-Type": "application/json",
            },
          })
            .then((res) => res.json())
            .catch((error) => console.error("Error:", error))
            .then((response) => {
              // console.log("Success:", response);
              // this.loading = false;
              this.filters_data.regions = response;
            });
        },
      },
    });
  },
  init: function () {
    Products.initVue();
  },
  
  isTaxonomy: {
    category: function () {
      return _actual.object && _actual.object.taxonomy == "category";
    },
    tag: function () {
      return _actual.object && _actual.object.taxonomy == "post_tag";
    },
    source: function () {
      return _actual.object && _actual.object.taxonomy == "source";
    },
    region: function () {
      return _actual.object && _actual.object.taxonomy == "region";
    },
  },
};

export default Products;



// WEBPACK FOOTER //
// ./resources/assets/js/filter.js